
    import { defineComponent } from 'vue'
    import Badge from 'primevue/badge'
    import { mapState } from 'vuex'

    export default defineComponent({
        name: 'kn-menu-item',
        components: { Badge },
        emits: ['click'],
        props: {
            item: null,
            badge: null,
            internationalize: { type: Boolean, required: false, default: false }
        },
        data() {
            return {
                openedLi: false
            }
        },
        methods: {
            onClick(event, navigate): void {
                this.$emit('click', {
                    originalEvent: event,
                    item: this.item,
                    navigate: navigate
                })
            },
            toggleSubMenu() {
                this.openedLi = !this.openedLi
            },

            getVisibilityClass(item) {
                if (!item.conditionedView) return true

                return !item.visible ? 'display:none' : ''
            },
            getInternationalizedValue(): String {
                let value = this.item.descr ? this.item.descr : this.item.label
                if (this.internationalize) {
                    // @ts-ignore
                    return this.$internationalization(value)
                } else {
                    return this.$t(value)
                }
            }
        },
        computed: {
            ...mapState({
                locale: 'locale'
            }),
            cleanTo(): any {
                return this.item.to.replace(/\\\//g, '/')
            }
        }
    })
